import React from "react";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { IndexLinkContainer } from "react-router-bootstrap";
import ReactGA from "react-ga";
import moment from "moment";
import "moment/locale/el";
import "moment/locale/it";
import { translate, getLanguage } from "../Translation/Translation";

const nav = {
  backgroundColor: "rgb(41,63,84)",
  borderColor: "rgb(140,216,248)",
  borderRadius: "0px",
  marginBottom: "0px",
};

class BottomNav extends React.Component {
  handleClick() {
    let newdate = new Date();
    ReactGA.event({
      category: "Events",
      action: "SearchForAllEvents",
      label: `${moment(newdate).format("YYYYMMDD")}#${moment(newdate).format(
        "hhmm"
      )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
    });
  }
  render() {
    let searchParams = JSON.parse(localStorage.getItem("currentSearch"));

    return (
      <div className="OSNavbarContainer" style={nav}>
        <div className="OSNavbar">
          <Navbar>
            <Nav>
              {searchParams && searchParams.outgoingLocationCode && (
                <IndexLinkContainer
                  to={`/${searchParams.outgoingLocationCode}/${searchParams.incomingLocationCode}/${searchParams.outgoingDate}/${searchParams.incomingDate}/itineraries`}
                  activeClassName="active"
                >
                  <NavItem className="stylenav" eventKey={2}>
                    {translate(getLanguage(), "Itineraries")}
                  </NavItem>
                </IndexLinkContainer>
              )}
              <IndexLinkContainer
                to="/allevents"
                activeClassName="active"
                onClick={() => {
                  this.handleClick();
                }}
              >
                <NavItem className="stylenav" eventKey={3}>
                  {translate(getLanguage(), "Events")}
                </NavItem>
              </IndexLinkContainer>
              <IndexLinkContainer to="/allagencies" activeClassName="active">
                <NavItem className="stylenav" eventKey={4}>
                  {translate(getLanguage(), "Agencies")}
                </NavItem>
              </IndexLinkContainer>
              <IndexLinkContainer
                to="/advertising-interest"
                activeClassName="active"
              >
                <NavItem className="stylenav" eventKey={5}>
                  {translate(getLanguage(), "Advertise with us")}
                </NavItem>
              </IndexLinkContainer>
              <IndexLinkContainer to="/contact" activeClassName="active">
                <NavItem className="stylenav" eventKey={7}>
                  {translate(getLanguage(), "Contact Us")}
                </NavItem>
              </IndexLinkContainer>
            </Nav>
          </Navbar>
        </div>
      </div>
    );
  }
}

export default BottomNav;



// WEBPACK FOOTER //
// ./src/components/Header/BottomNav.js